<template>
  <div class="min-h-screen bg-ink-50">
    <!-- Sidebar desktop -->
    <AppSidebar v-if="!isMobile" class="hidden md:flex" @open-search="onSearch" />

    <!-- Main -->
    <div :class="mainClasses">
      <slot />
    </div>

    <!-- Bottom nav mobile -->
    <AppMobileNav v-if="isMobile" class="md:hidden" />
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import AppSidebar from './AppSidebar.vue'
import AppMobileNav from './AppMobileNav.vue'

const isMobile = ref(false)
const update = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  update()
  window.addEventListener('resize', update)
})
onBeforeUnmount(() => window.removeEventListener('resize', update))

const mainClasses = computed(() => [
  'min-h-screen flex flex-col',
  isMobile.value ? 'pb-20' : 'md:ml-60'
])

const onSearch = () => {
  // Hook futur : ouvrir command palette ⌘K

  console.log('Search palette — TODO')
}
</script>
